import { LoanApplicationTabId } from 'app/pages/loanApplication/LoanApplication.constants';

import {
  deleteApplicationBorrowerAction,
  deleteNonBorrowerEntityAction,
} from 'store/loanApplications/actions';

import { ENTITY_TYPE_HREF } from '../EditEntityModal/EditEntityModal.constants';

export const INVITE_CO_BORROWER_MENU_LABEL = 'Invite Co-Borrower';

export const DELETE_ENTITY_CONTENT_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: {
    modalMessage: 'Remove Borrower',
    modalDescription: 'Are you sure you want to remove this borrower?',
    action: deleteApplicationBorrowerAction,
    getParams: ({ entityId, applicationId }) => ({
      applicationId,
      borrowerId: entityId,
      tabId: LoanApplicationTabId.PERSONAL_INFORMATION,
    }),
    successMessage: 'Borrower is successfully deleted',
  },
  [ENTITY_TYPE_HREF.NON_BORROWER]: {
    modalMessage: 'Remove Non Borrower Entity',
    modalDescription: 'Are you sure you want to remove this entity?',
    action: deleteNonBorrowerEntityAction,
    getParams: ({ entityId, applicationId }) => ({
      applicationId,
      nonBorrowerEntityId: entityId,
      tabId: LoanApplicationTabId.PERSONAL_INFORMATION,
    }),
    successMessage: 'Non Borrower Entity is successfully deleted',
  },
};
